import(/* webpackMode: "eager" */ "/tmp/8def0913fcb00a8/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/tmp/8def0913fcb00a8/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Nunito_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"300\",\"400\",\"600\",\"700\"]}],\"variableName\":\"nunito_sans\"}");
;
import(/* webpackMode: "eager" */ "/tmp/8def0913fcb00a8/src/app/globals.css");
